export function trackCallClick(location: string) {
  if (typeof window === "undefined") return;
  const p = (window as any).plausible;
  if (typeof p !== "function") return;
  p("Call Now Click", {
    props: {
      location,
      page: window.location.pathname,
      referrer: document.referrer || "direct",
    },
  });
}
